angular.module('bmsApp.settings')
	.controller('WebexIntegrationCtrl', function ($scope,
																								$timeout,
																								AppSettingsSvc,
																								WebexInteractSvc,
																								notify) {

		var form = {
			validatorConfig: {
				submitHandler: function () {
					$timeout(function () {
						form.processing = true;
						self.errors = null;
						AppSettingsSvc.update(form.settingsData)
							.then(function (response) {
								notify({
									message: 'Settings saved'
								});
								form.settingsData = response.data.settings;
							}, function (errors) {
								self.errors = errors;
							})
							.finally(function () {
								form.processing = false;
							})
						;
					});
				}
			},
			validatorApi: {},
			settingsData: {
				mobile_number: '',
			},
			credentialsVerified: false,
			showMobileNumberSection: false,
			showVerificationSection: false,
			processing: false
		};

		var self = {
			methods: {
				init: function () {
					AppSettingsSvc.index()
						.then(function (response) {
							form.settingsData = response.data.settings;
							console.log(form.settingsData.webex_sms_from_name);
							if (form.settingsData.webex_sms_from_name && form.settingsData.webex_sms_api_key) {
								form.credentialsVerified = true;
							}
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							self.loading = false;
						});
				},

				enableMobileNumberSection: function () {
					self.errors = [];
					self.methods.validateCredentials();
					if (self.errors.length > 0) {
						return;
					}

					form.showMobileNumberSection = true;
					form.credentialsVerified = false;
				},

				sendVerificationCode: function () {
					self.errors = [];
					self.methods.validateCredentials();
					self.methods.validateMobileNumber();
					if (self.errors.length > 0) {
						return;
					}

					form.sendingVerificationCode = true;
					WebexInteractSvc.sendVerificationCode(form.settingsData)
						.then(function (response) {
							notify({
								message: 'Verification code sent successfully.'
							});
							form.showVerificationSection = true;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							form.sendingVerificationCode = false;
						});
				},

				verifyAndSave: function () {
					self.errors = [];
					self.methods.validateCredentials();
					self.methods.validateMobileNumber();
					self.methods.validateVerificationCode();
					if (self.errors.length > 0) {
						return;
					}

					form.processing = true;
					WebexInteractSvc.verifyAndSave(form.settingsData)
						.then(function (response) {
							notify({
								message: 'Settings saved'
							});
							form.credentialsVerified = true;
							form.showMobileNumberSection = false;
							form.showVerificationSection = false;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							form.processing = false;
						});
				},

				validateCredentials: function() {
					if (form.settingsData.webex_sms_from_name == '' || form.settingsData.webex_sms_from_name == ' ') {
						self.errors.push('From name is required');
					}
					if (form.settingsData.webex_sms_api_key == '' || form.settingsData.webex_sms_api_key == ' ') {
						self.errors.push('API key is required');
					}
				},

				validateMobileNumber: function() {
					if (!form.settingsData.mobile_number || form.settingsData.mobile_number == '' || form.settingsData.mobile_number == ' ') {
						self.errors.push('Mobile number is required or invalid');
					}
				},

				validateVerificationCode: function() {
					if (!form.settingsData.webex_sms_verification_code || form.settingsData.webex_sms_verification_code == '' || form.settingsData.webex_sms_verification_code == ' ') {
						self.errors.push('Verification code is required');
					}
				}

			},
			form: form,
			loading: true,
			errors: null
		};

		$scope.WebexIntegrationCtrl = self;

	});
